import {Compiler, Inject, Injectable, InjectionToken, NgModuleFactory} from "@angular/core";

export abstract class ModuleEnsurer {
  abstract resolve(name: string): Promise<any>;
}

export const MODULE_ENSURER = new InjectionToken<ModuleEnsurer>("module loader");

@Injectable({providedIn: "root"})
export class ModuleLoaderService {

  private loadedModules = {};

  constructor(private compiler: Compiler,
              @Inject(MODULE_ENSURER) private ensurer: ModuleEnsurer) {

  }

  load(name: string): Promise<NgModuleFactory<any>> {
    if (this.loadedModules[name]) {
      return Promise.resolve(this.loadedModules[name]);
    }

    return this.ensureAndCompile(name).then(factory => {
      return this.loadedModules[name] = factory;
    });
  }

  private ensureAndCompile(moduleName: string): Promise<any> {
    const isOffline = this.compiler instanceof Compiler;
    return this.ensurer.resolve(moduleName).then(m => {
      return isOffline ? m : this.compiler.compileModuleAsync(m);
    });
  }

}
